import { GetUserDto } from '../../../../../models/view/employee';

export enum FreemiumManagePersonCascadingPanelIds {
  Sections = 'sections',
  Permissions = 'permissions',
}

export interface IFreemiumManagePersonCascadingPanelsProps {
  personId: string | undefined;
  onCancel: () => void;
}

export interface IFreemiumManagePersonFocusPanelProps {
  person: GetUserDto | undefined;
  onClickSection: (section: FreemiumManagePersonCascadingPanelIds) => void;
  onCancel: () => void;
  onSave: (personSlug: string) => void;
}

export interface IFreemiumManagePersonDetailsLayoutProps {
  person: GetUserDto | undefined;
  onSubmit: (personSlug: string) => void;
}